import { Pipe, PipeTransform } from '@angular/core';

import { IEnclosure } from '../../shared/models/enclosure.model';
import { EnclosureTypes } from '../../enclosure/models/enclosure-type.model';

@Pipe({
    name: 'isPrismaXsEnclosure',
    standalone: false
})
export class IsPrismaXsEnclosurePipe implements PipeTransform {

  transform(enclosure: IEnclosure): boolean {
    return enclosure?.enclosureType === EnclosureTypes.PRISMA_XS;
  }

}
